import { defineStore, storeToRefs } from 'pinia';
import { useCarComparisonStore } from '../carComparisonStore';

interface IModalStore {
  showMakeModelModal: boolean;
  modalToDisplayOnLoad: string;
}

const carComparisonStore = useCarComparisonStore();
const { showCarComparisonFooter } = storeToRefs(carComparisonStore);

export const useModalStore = defineStore('modalStore', {
  state: (): IModalStore => ({
    showMakeModelModal: false,
    modalToDisplayOnLoad: '',
  }),
  actions: {
    closeShowMakeModelModal() {
      this.showMakeModelModal = false;
    },
    toggleMakeModelModal(searchOption = '') {
      showCarComparisonFooter.value = false;
      this.modalToDisplayOnLoad = searchOption;
      this.showMakeModelModal = !this.showMakeModelModal;
    },
  },
  getters: {},
  persist: false,
});
